<app-toolbar></app-toolbar>
<div class="body-estruct">
    <div class="container">
        <div class="row">
            <div class="col lh-15vh">&nbsp;</div>
        </div>
        <div class="row align-items-center">
            <div class="col-12 col-lg-4">
                <img alt="" src="../../assets/images/Ilustración02.png">
            </div>
            <div class="col-12 col-lg-8">
                <h1 class="titulo mt-30x">¡Felicidades, ahora tú y tus acompañantes están protegidos!</h1>
                <div class="lbl-subtitle">Recuerda que ya puedes descargar nuestra app, con la que podrás llevar el control de tus pólizas y conocer más detalles de las mismas. </div>
            </div>
        </div>
        <div class="row">
            <div class="col lh-15vh">&nbsp;</div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 offset-md-3 align-self-center text-center">
                <div class="lbl-subtitle">
                    Para cualquier duda adicional, recuerda que puedes comunicarte con nosotros a nuestra línea Inter: <label class="link-inter">55442 46837</label>
                </div>
            </div>
        </div>
    </div>
</div>
